import { typeahead } from "@mirage/service-typeahead-search/service/types";

export function getSourceLimit(
  resultType: typeahead.ResultType,
  query: string,
  mode: typeahead.Mode,
  config: typeahead.Config,
  grossLimit: number,
  sectionLimit?: number,
) {
  if (resultType === typeahead.ResultType.CalendarEvent) {
    return 3;
  }

  if (resultType === typeahead.ResultType.RecentChat) {
    return mode === typeahead.Mode.Ask && !query.length ? 4 : 2;
  }

  if (resultType === typeahead.ResultType.PreviousQuery) {
    if (mode === typeahead.Mode.Find && !query.length) {
      return 4;
    }
    if (query.length && config.isDualModeLauncher) {
      return 1;
    }
    return 2;
  }

  if (resultType === typeahead.ResultType.PeopleFilter && query.length > 0) {
    return config.isDualModeLauncher ? 1 : 2;
  }

  if (
    resultType === typeahead.ResultType.PeopleRecommendation &&
    query.length > 0
  ) {
    return config.isDualModeLauncher ? 1 : 2;
  }

  return sectionLimit ?? grossLimit;
}
